import {
  gql 
} from "@apollo/client";

export const ADD_WEDDINGPLANNER = gql`
    mutation addWeddingPlanner(
      $emailaddress: String!
      $firstname: String!
      $lastname: String!
      $address: String!
      $companyname: String!
      $companywebsite: String!
      $jobtitle: String!
      $instagram: String!
      $weddingcount: String!
      $suggestion: String
    ) {
      addWeddingPlanner(
            input: {
              emailaddress: $emailaddress
              firstname: $firstname
              lastname: $lastname
              address: $address
              companyname: $companyname
              companywebsite: $companywebsite
              jobtitle: $jobtitle
              instagram: $instagram
              weddingcount: $weddingcount
              suggestion: $suggestion
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addWeddingPlannerMutation: ADD_WEDDINGPLANNER,
};
